import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Season} from '../../helper/season.model';
import {YoungViewModel} from '../../../components/young-info/young-info-view-model/YoungViewModel';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgIf } from '@angular/common';
import {MatExpansionModule} from "@angular/material/expansion";

@Component({
    selector: 'app-dialog-authorisation',
    templateUrl: './dialog-authorisation.component.html',
    styleUrls: ['./dialog-authorisation.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgIf, MatDialogTitle, MatDialogContent, MatCheckboxModule, MatDialogActions, MatButtonModule, MatExpansionModule]
})
export class DialogAuthorisationComponent implements OnInit {
    dialogRef = inject<MatDialogRef<DialogAuthorisationComponent>>(MatDialogRef);
    private readonly fb = inject(UntypedFormBuilder);


    isSportDansLaVille = false;
    isJobDansLaVille = false;
    isRdlv = false;

    formGroupRGPD: UntypedFormGroup = null;
    isInformationValid: boolean = false;
    isMinor: boolean;
    young: YoungViewModel;

    readonly season: Season = new Season();

    get youngName() {
        return `${this.young.firstname} ${this.young.lastname}`;
    }

    get legalResponsibleName() {
        if (this.young?.legalResponsibles?.length > 0) {
            return `${this.young.legalResponsibles[0].firstname} ${this.young.legalResponsibles[0].lastname}`;
        }
        return '';
    }

    ngOnInit() {
        this.formGroupRGPD = this.fb.group({
            isInformationValidSport: [false, Validators.required],
            isInformationValidJob: [false, Validators.required],
            isInformationValidRdlv: [false, Validators.required]
        });

        this.formGroupRGPD.controls.isInformationValidSport.valueChanges.subscribe((value: boolean) => {
            this.isInformationValid = value;
        });

        this.formGroupRGPD.controls.isInformationValidJob.valueChanges.subscribe((value: boolean) => {
            this.isInformationValid = value;
        });

        this.formGroupRGPD.controls.isInformationValidRdlv.valueChanges.subscribe((value: boolean) => {
            this.isInformationValid = value;
        });
    }

    closePopup() {
        this.dialogRef.close(this.isInformationValid);
    }
}
